import { render, staticRenderFns } from "./Func11ExtratoCoparticipacao.vue?vue&type=template&id=2d44ddb2&scoped=true"
import script from "./Func11ExtratoCoparticipacao.vue?vue&type=script&lang=js"
export * from "./Func11ExtratoCoparticipacao.vue?vue&type=script&lang=js"
import style0 from "./Func11ExtratoCoparticipacao.vue?vue&type=style&index=0&id=2d44ddb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44ddb2",
  null
  
)

export default component.exports